import { getOrderHisDetailPanel } from "../../services/OrderHisDetailServices";
import { PedidosHistorialDetalleContext } from "./PedidosHistorialDetalleContext"

export const PedidosHistorialDetalleState = ({ children }) => {
    const getPedidosHistorialDetallePanelData = async (searchOca, searchArt, page, perPage) => {
       let res = await getOrderHisDetailPanel(searchOca, searchArt, page, perPage)
       return res;
    };
    
    return <PedidosHistorialDetalleContext.Provider value={{
        getPedidosHistorialDetallePanelData,
    }} >
        {children}
    </PedidosHistorialDetalleContext.Provider>
}